import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import {history} from 'instantsearch.js/es/lib/routers';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import components from '../algolia';

const downloadTypeLookup = [
  {name: 'Architectural Worksheet', key: 'architectural_worksheet'},
  {name: 'BIM Model', key: 'bim_model'},
  {name: 'Brochure', key: 'brochure'},
  {name: 'CAD Drawing', key: 'cad_drawing'},
  {name: 'Identification Guide', key: 'identification_guide'},
  {name: 'Information Sheet', key: 'information_sheet'},
  {name: 'Installation Instructions', key: 'installation_instructions'},
  {name: 'Pricing Sheet', key: 'pricing_sheet'},
  {name: 'Product Guide', key: 'product_guide'},
  {name: 'Repair & Maintenance Guide', key: 'repair_guide'},
  {name: 'SDS Safety Data Sheet', key: 'safety_data_sheet'},
  {name: 'Sell Sheet', key: 'sell_sheet'},
  {name: 'Spec Sheet', key: 'spec_sheet'},
  {name: 'White Paper', key: 'white_paper'}
];

const loadTechnicalDownloads = () => {
  if (document.querySelector('.technical-docs')) {
    new Vue({
      el: '.technical-docs',
      comments: true,
      components,
      data() {
        const indexName = this.$algolia.indexPrefix + 'technical_downloads';

        const routing = {
          router: history(),
          stateMapping: {
            stateToRoute(uiState) {
              const indexUiState = uiState[indexName] || {};
              return {
                query: indexUiState.query,
                product_type: indexUiState.menu?.product_type,
                download_type: indexUiState.menu?.download_type
              };
            },
            routeToState(routeState) {
              return {
                [indexName]: {
                  query: routeState.query,
                  menu: {
                    product_type: routeState.product_type,
                    download_type: routeState.download_type
                  }
                }
              };
            }
          }
        };

        return {
          indexName,
          routing,
          filterString: 'NOT download_type:\'Spec Sheet\'',
          downloadIds: [],
          downloadPackagerLink: '',
          downloadPackagerLoading: false,
          downloadPackagerError: false,
          googleTrackingCodes: {}
        };
      },
      created() {
        this.googleTrackingCodes = JSON.parse(
          document.querySelector('.technical-docs').dataset.googleTrackingCodes
        );
      },
      mounted() {
        $(document).on('click', '#downloadPackager .success a', () => {
          $('#downloadPackager').modal('hide');
        });
      },
      methods: {
        handleClick(id) {
          if (this.downloadIds.includes(id)) {
            const index = this.downloadIds.indexOf(id);
            this.downloadIds.splice(index, 1);
          } else {
            this.downloadIds.push(id);
          }
        },
        downloadFiles() {
          if (this.downloadIds.length >= 50) {
            this.downloadPackagerError = 'too_many';
            this.downloadPackagerLink = '';
            this.downloadPackagerLoading = false;
          } else {
            this.downloadPackagerError = false;
            this.downloadPackagerLink = '';
            this.downloadPackagerLoading = true;

            $.ajax({
              url: `/download/packager/build?nids=${this.downloadIds}`
            })
              .done(data => {
                this.downloadPackagerError = false;
                this.downloadPackagerLink = data;
                this.downloadPackagerLoading = false;
              })
              .catch(() => {
                this.downloadPackagerError = true;
                this.downloadPackagerLink = '';
                this.downloadPackagerLoading = false;
              });
          }
        },
        recordClickTracking(item, sendEvent) {
          sendEvent('click', item, 'Technical Downloads Result Clicked');
          this.recordAnalyticsGoal(item.download_type);
        },
        recordAnalyticsGoal(downloadTypeName) {
          const downloadType = downloadTypeLookup.find(
            type => type.name === downloadTypeName
          );
          if (downloadType) {
            const key = downloadType.key;
            window.ga('send', 'event', {
              eventCategory: this.googleTrackingCodes[key]
                .category,
              eventAction: 'download',
              eventLabel: this.googleTrackingCodes[key].label
            });
          }
        }
      },
      router
    });
  }
};

export default loadTechnicalDownloads;
